import types from "../types";

const initialState = {
  filter: {
    franchise: null,
    address: null,
  },
  timeFrame: 'week',
};

const filterReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_FILTER:
      return {
        ...state,
        filter: payload,
      }

    case types.SET_TIME_FRAME:
      return {
        ...state,
        timeFrame: payload,
      }

    case types.CLEAR_FILTER:
      return {
        ...initialState,
      }
      
    default:
      return state
  }
}

export default filterReducer;